import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { OidcErrorPayload, OidcTokenPayload } from "./open-id-connect.model";

export const ACTION_PREFIX = "[Open Id Connect Verification]";
export const OPEN_ID_CONNECT_ACTION_TYPE = {
	/**
	 * Sets the open id connect token in state upon succesful verification
	 */
	setOpenIdConnectToken: `${ACTION_PREFIX} Set Open Id Connect Token ${SYNC_SUFFIX}`,
	/**
	 * Clears the open id connect token in state
	 */
	clearOpenIdConnectToken: `${ACTION_PREFIX} Clear Open Id Connect Token ${SYNC_SUFFIX}`,
	/**
	 * Sets the open id connect error in state upon failed verification
	 */
	setOpenIdConnectError: `${ACTION_PREFIX} Set Open Id Connect Error ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class OpenIdConnectAction {
	setOpenIdConnectToken(payload: OidcTokenPayload): ActionWithPayload {
		return {
			type: OPEN_ID_CONNECT_ACTION_TYPE.setOpenIdConnectToken,
			payload,
		};
	}

	clearOpenIdConnectToken(): Action {
		return {
			type: OPEN_ID_CONNECT_ACTION_TYPE.clearOpenIdConnectToken,
		};
	}

	setOpenIdConnectError(payload: OidcErrorPayload): ActionWithPayload {
		return {
			type: OPEN_ID_CONNECT_ACTION_TYPE.setOpenIdConnectError,
			payload,
		};
	}
}
